// extracted by mini-css-extract-plugin
module.exports = {"perkCard":"perk_perkCard__uw9qU","perkImg":"perk_perkImg__BCwAI"};